import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { siteSpecificData } from '../../../environments/site-specific-data';
import { OutstandingDebt } from '../models/outstanding-debt';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class OutstandingDebtService {

  constructor(private http: HttpClient) { }

  getOutstandingDebtByPropertyRef(ref: number): Observable<OutstandingDebt> {
    const outstandingDebtByPropertyRefUrl = `${API_URL}properties/${ref}/outstandingdebt`;
    return this
      .http
      .get<OutstandingDebt>(outstandingDebtByPropertyRefUrl)
      .pipe();
  }

}
